import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { cartLineCardCondensedStyles } from "@insite/content-library/Components/CartLineCardCondensed";
import { css } from "styled-components";

cartLineCardCondensedStyles.productDescription = {
    productDetailLink: {
        css: css`
            width: 100%;
            span {
                color: #33333A !important;
                font-size: 16px;
                font-weight: 600;
                &:hover {
                    color: #006bc0 !important;
                }
            }
        `,
        typographyProps: {
            css: css`
                width: 100%;
                ${wrapInContainerStyles}
            `,
        },
    },
}

cartLineCardCondensedStyles.productErpNumberText = {
    css: css`
            width: 100%;
            word-wrap: break-word;
            font-size: 14px;
            font-weight: 500;
            color: #006bc0;
        `,
}